/**
 * Step 1: Configuration — shared fields + interval mode.
 * Full-width layout with spacious padding.
 */

import type { PreparedDrop } from '@/features/smswiser-campaigns/types/workspace.types';

import { SharedFieldsSection } from '../config/SharedFieldsSection';
import { IntervalModeSection } from '../config/IntervalModeSection';
import { useMultiCountryIntervals } from '../hooks/useMultiCountryIntervals';
import type { useMultiCountryBulkEditForm } from '../hooks';

type Form = ReturnType<typeof useMultiCountryBulkEditForm>;

interface Props {
  form: Form;
  selectedIds: string[];
  mergedDrops: PreparedDrop[];
  tlds: Array<{ value: string; displayName: string }>;
  isBusy: boolean;
}

export function ConfigStep({ form, selectedIds, mergedDrops, tlds, isBusy }: Props) {
  const intervals = useMultiCountryIntervals({
    ids: selectedIds,
    mergedDrops,
    baseUtcIso: form.executeAfter,
    intervalMinutes: form.scheduleIntervalMinutes,
    mode: form.intervalMode,
    enabled: form.scheduleMode === 'apply' && !!form.executeAfter && form.scheduleIntervalMinutes > 0,
  });

  return (
    <div className="flex flex-col gap-5 p-5">
      <SharedFieldsSection form={form} tlds={tlds} isBusy={isBusy} />
      <IntervalModeSection
        mode={form.intervalMode}
        onChange={form.setIntervalMode}
        preview={intervals.preview}
        hasSchedule={form.scheduleMode === 'apply' && !!form.executeAfter}
        hasInterval={form.scheduleIntervalMinutes > 0}
        disabled={isBusy}
      />
    </div>
  );
}
